module.exports = __webpack_public_path__ + "img/kaftor_yes.7f0d84df.png";